import { gateway } from "../../../../gateway";

export const deleteJobEventAction = async (jobEventId: string): Promise<void> => {
    try {
        if (!jobEventId) throw new Error("Job Event ID is required.");

        await gateway.delete(`/jobs/event/${jobEventId}`);

    } catch (error: any) {
        console.error('Error deleting job event', error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete job event';
        throw new Error(errorMessage);
    }
}
